import { render, staticRenderFns } from "./NewAnticipation.vue?vue&type=template&id=a7a1f1e6"
import script from "./NewAnticipation.vue?vue&type=script&lang=js"
export * from "./NewAnticipation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports